import { Box, Typography } from '@mui/material';
import { CHART_GREEN } from '../../../theme/theme-colors';

interface TimerDurationDisplayProps {
  time: string;
  ariaLabel: string;
  color?: string;
}

/** Large centered M:SS (or H:MM:SS) duration readout shared by program and countdown timer widgets. */
export function TimerDurationDisplay({ time, ariaLabel, color = CHART_GREEN }: TimerDurationDisplayProps) {
  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      flexShrink={1}
      aria-label={ariaLabel}
      data-testid="timer-duration-display"
      sx={{
        // Scale the readout with the widget body so 2x1 cells stay readable.
        containerType: 'size',
      }}
    >
      <Typography
        component="p"
        sx={{
          color,
          fontWeight: 600,
          lineHeight: 1,
          fontSize: '5rem',
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          px: 1,
          '@supports (height: 1cqh)': {
            fontSize: 'clamp(1.75rem, 50cqh, 5rem)',
          },
        }}
      >
        {time}
      </Typography>
    </Box>
  );
}
